import { Flex, LayoutProps, Text } from '@chakra-ui/react'
import { CaretDown } from 'phosphor-react'
import { ElementType } from 'react'
import { useTranslation } from 'react-i18next'

import { TicketStatus } from '@/modules/tickets/domain/models/Ticket'

export function getTicketStatusPrimaryColor(status: TicketStatus) {
  switch (status) {
    case 'ANALYSIS':
      return '#CCA108'
    case 'COMPLETED':
      return '#2BBB6E'
    case 'PENDING':
      return '#DF8620'
    case 'WAITING':
      return '#077FDE'
    case 'IMPEDIMENT':
      return '#D5474C'
  }
}

export function getTicketStatusSecondaryColor(status: TicketStatus) {
  switch (status) {
    case 'ANALYSIS':
      return '#FFF1BF'
    case 'COMPLETED':
      return '#D9FFEB'
    case 'PENDING':
      return '#FFEDD9'
    case 'WAITING':
      return '#D4ECFF'
    case 'IMPEDIMENT':
      return '#FFD9DB'
  }
}

export function TicketTag({
  status,
  width
}: {
  status: TicketStatus
  width?: LayoutProps['w']
}) {
  const { t } = useTranslation()

  return (
    <Text
      w={width}
      borderRadius={'9999px'}
      py={1}
      px={2}
      textAlign={'center'}
      color={getTicketStatusPrimaryColor(status)}
      bgColor={getTicketStatusSecondaryColor(status)}
      fontSize={'14px'}
      fontWeight={'500'}
    >
      {t(
        `tickets.ticketStatus.${
          status.toLocaleLowerCase() as Lowercase<typeof status>
        }`
      )}
    </Text>
  )
}

export function TicketTagWithCaret({
  status,
  as,
  isDisabled
}: {
  status: TicketStatus
  as?: ElementType
  isDisabled: boolean
}) {
  const { t } = useTranslation()

  return (
    <Text
      as={as}
      borderRadius={'9999px'}
      py={1}
      px={2}
      textAlign={'center'}
      color={getTicketStatusPrimaryColor(status)}
      bgColor={getTicketStatusSecondaryColor(status)}
      fontSize={'14px'}
      fontWeight={'500'}
    >
      <Flex as={'span'} alignItems={'center'} gap={1}>
        {t(
          `tickets.ticketStatus.${
            status.toLocaleLowerCase() as Lowercase<typeof status>
          }`
        )}
        {!isDisabled && <CaretDown />}
      </Flex>
    </Text>
  )
}
